import { useSelect, dispatch } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { PanelRow, PanelBody, TextControl, TextareaControl, Button, Notice } from '@wordpress/components';

export default () => {
    const settings = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { faqs, global_faqs, show_wp_travel_utilities, options, modules } = settings;
    const { updateSettings } = dispatch('WPTravel/Admin');
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;

    const copyToClipboard = str => {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      };

      const addNewFaq = () => {
        let _faqs  = faqs;
        let newFaq = {
            question: '',
            answer: '',
        }

        updateSettings({
            ...settings,
            faqs: [..._faqs, newFaq ]
        })
        
    }
    const updateFaq = ( key, value, _tabIndex ) => {
        const { faqs } = settings;
        let _faqs = faqs;
        _faqs[_tabIndex][key] = value

        updateSettings({
            ...settings,
            faqs: [..._faqs]
        })
    }
    const removeFaq = (index) => { // Remove
        let filteredFaqs = [];
        filteredFaqs = faqs.filter( (data, newIndex) => {
            return newIndex != index;
        });

        updateSettings({
            ...settings,
            faqs: [...filteredFaqs]
        })
    }
    // New [object structure due to index key as timestamp ]
    const updateGlobalFaq = ( key, value, _tabIndex ) => {
        const { global_faqs } = settings;
        let _faqs = global_faqs;
        _faqs[_tabIndex][key] = value

        updateSettings({
            ...settings,
            global_faqs: {..._faqs}
        })
    }
    const removeGlobalFaq = (index) => { // Remove
        delete global_faqs[index];
        updateSettings({
            ...settings,
            global_faqs: { ...global_faqs }
        })
    }
    const addNewGlobalFaq = () => {
        let _faqs = global_faqs;
        let newIndex = Date.now() / 1000 | 0;
        _faqs[newIndex] = {
            question: '',
            answer: '',
        }
        updateSettings({
            ...settings,
            global_faqs: {..._faqs }
        })

        console.log( global_faqs )
        
    }
    if ( ! isActive ) {
        // To hide while disabling from addons settings
        return <></>;
    }
    let tempIndex = 0;
    return <>
        <PanelRow>
            <p>{_wp_travel.setting_strings.faqs.global_faqs_note}</p>
        </PanelRow> 
        <PanelRow>
            <TextControl
                readOnly={true}
                value="[wp_travel_utils_global_faq]"
                onClick={ (e) => { 
                    const {value} = e.target
                    copyToClipboard(value) 
                    e.target.focus();
                    alert( __( 'Shortcode Copied : [wp_travel_utils_global_faq]', 'wp-travel-pro' ) )  ;
                } }
            />
        </PanelRow> 

        {
        'undefined' !== typeof global_faqs  ?
            <>
                {/* New Faqs */}
                { Object.keys( global_faqs ).length > 0 ?
                    <>
                        <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => addNewGlobalFaq()}>{ _wp_travel.setting_strings.faqs.add_new }</Button></PanelRow>
                        {Object.keys(global_faqs).map( ( index ) =>{
                            tempIndex++;
                            return <PanelBody
                                title={ 'undefined' != typeof global_faqs[index].question && global_faqs[index].question ? global_faqs[index].question :  __( `Question ${tempIndex} `, 'wp-travel-pro' )}
                                initialOpen={false}
                                >
                                <PanelRow>
                                    <label>{_wp_travel.setting_strings.faqs.enter_your_question}</label>
                                    <div className="wp-travel-field-value">
                                        <TextControl
                                            placeholder={__( 'FAQ Question?', 'wp-travel-pro' )}
                                            value={global_faqs[index].question}
                                            onChange={(value) => {
                                                updateGlobalFaq( 'question', value, index ) 
                                            }}
                                        />
                                    </div>
                                </PanelRow>
                                <PanelRow>
                                    <label>{_wp_travel.setting_strings.faqs.enter_your_answer}</label>
                                    <div className="wp-travel-field-value">
                                        <TextareaControl
                                            value={global_faqs[index].answer}
                                            onChange={ 
                                                (value) => {
                                                    updateGlobalFaq( 'answer', value, index )
                                                }
                                            }
                                        />
                                    </div>
                                </PanelRow>

                                <PanelRow className="wp-travel-action-section">
                                <span></span>
                                <Button variant="secondary" onClick={() => {
                                    if (!confirm(_wp_travel.setting_strings.faqs.remove_faq_note )) {
                                        return false;
                                    }
                                    removeGlobalFaq(index);
                                }} className="wp-traval-button-danger">{_wp_travel.setting_strings.faqs.remove_faq}</Button></PanelRow>

                                
                            </PanelBody>
                        } )}

                        {Object.keys(global_faqs).length > 2 && <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => addNewGlobalFaq()}>{ _wp_travel.setting_strings.faqs.add_new }</Button></PanelRow>}
                    </>
                    :
                    <><Notice isDismissible={false} actions={[{
                        'label':_wp_travel.setting_strings.faqs.add_faq,
                        onClick:()=>{
                            addNewGlobalFaq()
                        },
                        noDefaultClasses:true,
                        className:'is-link'
                    }]}>{_wp_travel.setting_strings.faqs.no_faq_found}</Notice></>
                }
            </>
            :
            <>
                { 'undefined' != typeof faqs && faqs.length > 0 ?
                    <>
                        <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => addNewFaq()}>{ _wp_travel.setting_strings.faqs.add_new }</Button></PanelRow>
                        {faqs.map( ( faq, index ) =>{
                            return <PanelBody
                                title={ 'undefined' != typeof faq.question && faq.question ? faq.question :  __( `Question ${index + 1} `, 'wp-travel-pro' )}
                                initialOpen={false}
                                >
                                <PanelRow>
                                    <label>{ _wp_travel.setting_strings.faqs.enter_your_question }</label>
                                    <div className="wp-travel-field-value">
                                        <TextControl
                                            placeholder={__( 'FAQ Question?', 'wp-travel-pro' )}
                                            value={faq.question}
                                            onChange={(value) => {
                                                updateFaq( 'question', value, index ) 
                                            }}
                                        />
                                    </div>
                                </PanelRow>
                                <PanelRow>
                                    <label>{ _wp_travel.setting_strings.faqs.enter_your_answer }</label>
                                    <div className="wp-travel-field-value">
                                        <TextareaControl
                                            value={faq.answer}
                                            onChange={ 
                                                (value) => {
                                                    updateFaq( 'answer', value, index )
                                                }
                                            }
                                        />
                                    </div>
                                </PanelRow>

                                <PanelRow className="wp-travel-action-section">
                                <span></span>
                                <Button variant="secondary" onClick={() => {
                                    if (!confirm(_wp_travel.setting_strings.faqs.remove_faq_note )) {
                                        return false;
                                    }
                                    
                                    removeFaq(index);
                                }} className="wp-traval-button-danger">{_wp_travel.setting_strings.faqs.remove_faq }</Button></PanelRow>

                                
                            </PanelBody>
                        } )}

                        {faqs.length > 2 && <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => addNewFaq()}>{ _wp_travel.setting_strings.faqs.add_new }</Button></PanelRow>}
                    </>
                    :
                    <><Notice isDismissible={false} actions={[{
                        'label':_wp_travel.setting_strings.faqs.add_faq,
                        onClick:()=>{
                            addNewFaq()
                        },
                        noDefaultClasses:true,
                        className:'is-link'
                    }]}>{_wp_travel.setting_strings.faqs.no_faq_found}</Notice></>
                }
            </>
        }
    </>
}